<template>
<div class="chapter">
<div class="inner_page">
      ﻿

 <meta charset="utf-8"/> <link href="styles/default.css" rel="stylesheet" type="text/css"/> <title>Volume One</title>
<div class="chapter">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Volume One">
<h1 class="ct2" id="p0018-01-0">
<a id="page18">
<b>68</b>
</a></h1><a id="page18">
<h2 class="ct1">Be brave. Even if you’re not, pretend to be. <br/> No one can tell the difference.</h2>
</a></section><a id="page18">
</a></div>
<a id="page18">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter7.vue?1096224a